<template>
  <b-container class="mt-3">
    <b-card class="mt-4 mb-4" :body-class="isMobile ? 'p-2' : ''">
      <standard-table ref="obuTable"
                      :items="items"
                      :fields="fields"
                      :custom-fields="[{ key: 'myEdit', label: '' }]"
                      :search-place-holder="`${$tc('message.example', 1)}: 74827428`"

                      :row-search="{cols: 12,sm: 12,md: 12,lg: 4,xl: 4,order: 1,orderSm: 2,orderMd: 2,orderLg: 1,orderXl: 1}"
                      :row-after-search="{cols: 12, sm: 12, md: 12, lg: 8, xl: 8, order: 2, orderSm: 3, orderMd: 3, orderLg: 2, orderXl: 2}"

                      :row-pagination="{cols: 12, sm: 12, md: 6, lg: 5, xl: 5}"
                      :row-between-pagination="{cols: 12, sm: 12, md: 1, lg: 1, xl: 4}"
                      :row-per-page="{cols: 12, sm: 12, md: 5, lg: 3, xl: 2}"
                      :row-after-per-page="{cols: 12, sm: 12, md: 12, lg: 3, xl: 1}"

                      :search-label-horizontal="false"
                      fullWidth="true"
                      noContainerPadding="true"
                      @rowEdit="$event.item.associated
                      ? $router.push({name: 'EditVehicle', params: {id: $event.item.vehicleId}, query: {tab: 'obu'}})
                      : showAssociationModal($event.item)">
        <b-container slot="row-after-search" class="mw-100 p-0 ">
          <b-row>
            <b-col cols="auto">
              <b-button v-on:click="resetFilters()" class="b-c-green" id="reset-filters">
                {{$t('message.resetFilters')}}
              </b-button>
            </b-col>

            <b-col cols="auto" class="mb-3">
              <b-button @click="showCollapse = !showCollapse" :class="showCollapse ? 'b-c-red' : 'b-c-green'">
                <span v-show="!showCollapse" class="when-opened">{{$t('message.show')}} {{$tc('message.filter', 2).toLowerCase()}}</span>
                <span v-show="showCollapse" class="when-closed">{{$t('message.hide')}} {{$tc('message.filter', 2).toLowerCase()}}</span>
              </b-button>
            </b-col>
          </b-row>
        </b-container>

        <b-container slot="after-search" class="mw-100 p-0">
          <b-collapse id="my-collapse" v-model="showCollapse">
            <b-container class="mw-100 m-0 p-0">
              <b-row>
                <b-col class="mb-3" cols="12" sm="12" md="6" lg="4" xl="4">
                  <b-form-group :label="`${$tc('message.status', 1)} ${$t('message.obu')}`"
                                label-for="obu-status">
                    <model-list-select id="obu-status"
                                       option-text="text"
                                       option-value="value"
                                       :placeholder="associatedOptions && associatedOptions.length !== 0 ? $t('message.selectOption') : $t('message.noOption')"
                                       v-model="associatedFilter"
                                       :list="associatedOptions">
                    </model-list-select>
                  </b-form-group>
                </b-col>
              </b-row>
            </b-container>
          </b-collapse>
        </b-container>

        <b-container :body-class="isMobile ? 'p-2' : ''" slot="row-after-per-page" class="mw-100 p-0">
          <b-row>
            <b-col>
              <b-button class="float-right mt-3 mt-md-0 mt-lg-0 mt-xl-0" id="excel-button" @click="handleExcel(`${$t('message.list')}_${$t('message.obu')}`, getExcelFields())">Excel</b-button>
            </b-col>
          </b-row>
        </b-container>
      </standard-table>
    </b-card>

    <b-modal ref="OBUAssociation" id="OBUAssociation" :title="`${$t('message.associate')} ${$t('message.obu')}: ${selectedOBU.serialNumber}`">
      <b-container>
        <b-row>
          <b-col>
            <b-form-group :label="`${$tc('message.vehicle', 2)} ${$tc('message.available', 2).toLowerCase()}`"
                          label-for="input-tracker">
              <model-list-select id="input-tracker"
                                 option-text="plateNumber"
                                 option-value="id"
                                 :placeholder="vehicleOptions && vehicleOptions.length !== 0 ? $t('message.selectOption') : $t('message.noOption')"
                                 v-model="vehicleSelected"
                                 :list="vehicleOptions">
              </model-list-select>
            </b-form-group>
          </b-col>
        </b-row>
      </b-container>

      <div slot="modal-footer" class="w-100 justify-content-end d-flex">
        <!-- config[crud], create - read - update - delete -->
        <b-button id="nw-obu-add-continue" class="m-1 b-c-green" :disabled="!vehicleSelected"
                  v-if="config.c"
                  @click="associateOBU(vehicleSelected)">{{$t('message.saveClose')}}
        </b-button>

        <b-button id="nw-obu-add-close" class="m-1 b-c-green"
                  @click="hideOBUAssociation()">{{$t('message.close')}}
        </b-button>
      </div>
    </b-modal>
  </b-container>
</template>

<script>
import Vue from 'vue'
import { cloneDeep, find, filter, orderBy } from 'lodash'
import logKeys from "@/plugins/log-keys";

export default {
  name: 'managementObu',
  created () {
    this.fetchData()
  },
  mounted () {
    this.$root.$on('change-lang', () => {
      if (this.$el.isConnected) {
        this.getOptions()
      }
    })
    this.$root.$on('resize', () => {
      this.checkWindowWidth()
    })
  },
  data () {
    const config = this.$route.meta.config

    return {
      config,
      isMobile: false,
      trackers: [],
      vehicles: [],
      fields: [],
      originalItems: [],
      items: [],
      associatedOptions: [],
      associatedFilter: '',
      selectedOBU: {},
      vehicleOptions: [],
      vehicleSelected: null,
      showCollapse: false
    }
  },
  watch: {
    associatedFilter (val) {
      this.items = this.getItems(val)
    }
  },
  methods: {
    fetchData () {
      this.$root.$emit('activeLoader', true)
      this.associatedFilter = ''
      this.getOptions().then(() => this.getVehicle())
    },
    getOptions () {
      const axiosArray = []
      this.getAssociatedOptions()
      this.getFields()
      axiosArray.push(this.getTrackers())
      return Vue.myAll(axiosArray).then(r => r).catch(error => {
        Vue.manageErrors(this, error, Vue.getDimetiorHttpCode())
        return false
      })
    },
    checkWindowWidth () {
      const size = Vue.myGetWindowSize()
      this.isMobile = (size !== 'md' && size !== 'lg' && size !== 'xl')
    },
    getAssociatedOptions () {
      this.associatedOptions = [
        { value: '', text: this.$t('message.all') },
        { value: true, text: this.$t('message.associated') },
        { value: false, text: `${this.$t('message.not')} ${this.$t('message.associated').toLowerCase()}` }
      ]
    },
    getFields () {
      this.fields = [
        // config[crud], create - read - update - delete
        { key: 'edit', label: '', hideInTable: !this.config.u && !this.config.r },
        { key: 'serialNumber', label: `${this.$t('message.serialNumber')} ${this.$t('message.obu')}`, sortable: true, sortDirection: 'desc' },
        { key: 'plateNumber', label: `${this.$tc('message.numberPlate', 1)}`, sortable: true, sortDirection: 'desc' },
        { key: 'brand', label: this.$t('message.brand'), sortable: true, sortDirection: 'desc' },
        { key: 'model', label: this.$tc('message.model', 1), sortable: true, sortDirection: 'desc' }
      ]
    },
    getTrackers () {
      return Vue.myGet(this, '/trackers', 'trackers').then((items) => {
        this.trackers = items
        return true
      }).catch(error => {
        Vue.manageErrors(this, error, Vue.getDimetiorHttpCode())
        return false
      })
    },
    getVehicle () {
      Vue.myGet(this, '/vehicles?all=true', 'vehicles').then((vehicles) => {
        const editedItems = []
        let trackers = cloneDeep(this.trackers)

        this.vehicleOptions = []
        const sortedVehicles = []

        vehicles.forEach(vehicle => {
          const foundedTracker = find(trackers, obj => vehicle.imei !== '' && !!vehicle.imei && !!obj.imei && obj.imei === vehicle.imei)
          const brand = vehicle.type && vehicle.type.brand ? vehicle.type.brand : ''
          const model = vehicle.type && vehicle.type.model ? vehicle.type.model : ''
          if (foundedTracker) {
            trackers = filter(trackers, obj => obj.imei !== vehicle.imei)
            const editedVehicle = {
              plateNumber: vehicle.plateNumber,
              brand,
              model,
              imei: foundedTracker.imei,
              serialNumber: foundedTracker.serialNumber,
              associated: true,
              vehicleId: vehicle.id
            }
            editedItems.push(editedVehicle)
          } else {
            sortedVehicles.push(vehicle)
          }
        })
        this.vehicleOptions = sortedVehicles

        trackers.forEach((tracker) => {
          editedItems.push({
            plateNumber: this.$tc('message.emptyValue', 1),
            imei: tracker.imei,
            serialNumber: tracker.serialNumber,
            associated: false,
            vehicleId: null
          })
        })

        this.originalItems = orderBy(editedItems, 'serialNumber')
        this.items = cloneDeep(this.originalItems)
        this.$root.$emit('activeLoader', false)
      }).catch(error => { Vue.manageErrors(this, error, Vue.getDimetiorHttpCode()) })
    },
    getItems (associated) {
      if (associated !== null && associated !== '') {
        return filter(cloneDeep(this.originalItems), obj => obj.associated === associated)
      }
      return cloneDeep(this.originalItems)
    },
    handleExcel (fileName, fields) {
      return this.$refs.obuTable.excel(fileName, fields)
    },
    getExcelFields () {
      return [
        { key: 'serialNumber', label: `${this.$t('message.serialNumber')} OBU`, sortable: true, sortDirection: 'desc' },
        { key: 'plateNumber', label: this.$tc('message.numberPlate', 1), sortable: true, sortDirection: 'desc' }
      ]
    },
    showAssociationModal (item) {
      this.selectedOBU = item
      this.vehicleSelected = null
      this.$refs.OBUAssociation.show()
    },
    hideOBUAssociation () {
      this.$refs.OBUAssociation.hide()
      this.selectedOBU = {}
    },
    resetFilters () {
      this.associatedFilter = ''
      this.$refs.obuTable.resetSearch()
    },
    associateOBU (vehicle) {
      const foundedVehicle = find(this.vehicleOptions, obj => obj.id === vehicle)
      if (foundedVehicle) {
        foundedVehicle.imei = this.selectedOBU.imei
        this.$refs.OBUAssociation.hide()
        this.selectedOBU = {}
        Vue.putOrPost(this, true, `/vehicles/${foundedVehicle.id}`, foundedVehicle, false).then(() => {

          this.logData(foundedVehicle.id, this.selectedOBU.serialNumber)

          Vue.success(this, `${this.$tc('message.obu', 1)} ${this.$t('message.associated').toLowerCase()}`)
          this.hideOBUAssociation()
          this.fetchData()
        }).catch(error => { Vue.manageErrors(this, error, Vue.getDimetiorHttpCode()) })
      } else {
        Vue.error(this, `${this.$tc('message.vehicle', 2)} ${this.$t('message.not').toLowerCase()} ${this.$tc('message.found', 1).toLowerCase()}`)
      }
    },
    logData (vehicleId, OBU) {
      const logObj = Vue.getLogObj(this,'put', '/obu_management')

      logObj.data.details = []

      if (vehicleId) logObj.data.details.push({text: 'message.vehicle', option: 1, value: vehicleId, key: logKeys.vehicle})
      if (OBU) logObj.data.details.push({text: 'message.obu', option: 1, value: OBU, key: logKeys.obu})

      Vue.myLogPost(logObj)
    }
  }
}
</script>
